import React, { useEffect, useState } from "react";
import axios from "axios";

const VerifyEmail = () => {
  const [message, setMessage] = useState("Verifying your email...");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (token) {
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_URL}/auth/verify-email?token=${token}`
        )
        .then((res) => setMessage(res.data.message))
        .catch((err) =>
          setMessage(
            err.response?.data?.message ||
              "Verification failed. Please try again or contact support."
          )
        );
    } else {
      setMessage("No verification token provided.");
    }
  }, []);

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "40px auto",
        padding: 24,
        border: "1px solid #eee",
        borderRadius: 8,
        textAlign: "center",
      }}
    >
      <h2>Email Verification</h2>
      <p>{message}</p>
    </div>
  );
};

export default VerifyEmail;
